// extracted by mini-css-extract-plugin
export var fadeInAnimation = "InsightsShorts-module--fadeInAnimation--275aa";
export var title = "InsightsShorts-module--title--208a4";